import { Badge } from '@givebutter/primitives/badge';
import * as SingleSelect from '@givebutter/primitives/single-select';

const RelativeDateOperatorOptions = () => (
    <>
        <SingleSelect.Item value="TODAY">
            <SingleSelect.ItemText>Today</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="YESTERDAY">
            <SingleSelect.ItemText>Yesterday</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="LAST-WEEK">
            <SingleSelect.ItemText>Last 7 days</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="LAST-TWO-WEEKS">
            <SingleSelect.ItemText>Last 14 days</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="LAST-MONTH">
            <SingleSelect.ItemText>Last 4 weeks</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="LAST-QUARTER">
            <SingleSelect.ItemText>Last 3 months</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="LAST-YEAR">
            <SingleSelect.ItemText>Last 12 months</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="MTD">
            <SingleSelect.ItemText>Month to date</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="QTD">
            <SingleSelect.ItemText>Quarter to date</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="YTD">
            <SingleSelect.ItemText>Year to date</SingleSelect.ItemText>
            <Badge size="sm" color="primary">
                Default
            </Badge>
        </SingleSelect.Item>
        <SingleSelect.Item value="ALL-TIME">
            <SingleSelect.ItemText>All time</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="CUSTOM" className="gap-1">
            <SingleSelect.ItemText>Custom</SingleSelect.ItemText>date range
        </SingleSelect.Item>
    </>
);

export { RelativeDateOperatorOptions };
